import { useEffect, useMemo, useRef, useState } from 'react';

const RECENT_KEY = 'support-emoji-recent-v2';
const RECENT_MAX = 24;

export const EMOJI_CATEGORIES: Array<{ id: string; title: string; icon: string; emojis: string[] }> = [
  {
    id: 'smileys',
    title: 'Смайлы и люди',
    icon: '😊',
    emojis: [
      '😀', '😁', '😂', '🤣', '😃', '😄', '😅', '😆', '😉', '😊', '😋', '😎', '😍', '😘', '🥰', '😗',
      '😙', '😚', '🙂', '🤗', '🤩', '🤔', '🤨', '😐', '😑', '😶', '🙄', '😏', '😣', '😥', '😮', '🤐',
      '😯', '😪', '😫', '🥱', '😴', '😌', '😛', '😜', '😝', '🤤', '😒', '😓', '😔', '😕', '🙃', '🤑',
      '😲', '☹️', '🙁', '😖', '😞', '😟', '😤', '😢', '😭', '😦', '😧', '😨', '😩', '🤯', '😬', '😰',
      '😱', '🥵', '🥶', '😳', '🤪', '😵', '😡', '😠', '🤬', '😷', '🤒', '🤕', '🤢', '🤮', '🥴', '😇',
      '🥳', '🥺', '🤠', '🤡', '🤥', '🤫', '🤭', '🧐', '🤓', '😈', '👿', '👹', '👺', '💀', '☠️', '👻',
      '👽', '👾', '🤖', '💩', '😺', '😸', '😹', '😻', '😼', '😽', '🙀', '😿', '😾', '👋', '🤚', '🖐️',
      '✋', '🖖', '👌', '🤌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '🖕', '👇', '☝️',
      '👍', '👎', '✊', '👊', '🤛', '🤜', '👏', '🙌', '👐', '🤲', '🤝', '🙏', '💪', '🦾', '🦵', '🦶',
    ],
  },
  {
    id: 'nature',
    title: 'Животные и природа',
    icon: '🐻',
    emojis: [
      '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🙈',
      '🙉', '🙊', '🐒', '🐔', '🐧', '🐦', '🐤', '🐣', '🐥', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗', '🐴',
      '🦄', '🐝', '🪱', '🐛', '🦋', '🐌', '🐞', '🐜', '🪰', '🪲', '🪳', '🦟', '🦗', '🕷️', '🕸️', '🦂',
      '🐢', '🐍', '🦎', '🦖', '🦕', '🐙', '🦑', '🦐', '🦞', '🦀', '🐡', '🐠', '🐟', '🐬', '🐳', '🐋',
      '🦈', '🐊', '🐅', '🐆', '🦓', '🦍', '🦧', '🦣', '🐘', '🦛', '🦏', '🐪', '🐫', '🦒', '🦘', '🦬',
      '🐃', '🐂', '🐄', '🐎', '🐖', '🐏', '🐑', '🦙', '🐐', '🦌', '🐕', '🐩', '🦮', '🐈', '🐓', '🦃',
      '🦤', '🦚', '🦜', '🦢', '🦩', '🕊️', '🐇', '🦝', '🦨', '🦡', '🦫', '🦦', '🦥', '🐁', '🐀', '🐿️',
      '🦔', '🌸', '💮', '🏵️', '🌹', '🥀', '🌺', '🌻', '🌼', '🌷', '🌱', '🪴', '🌲', '🌳', '🌴', '🌵',
    ],
  },
  {
    id: 'food',
    title: 'Еда и напитки',
    icon: '🍔',
    emojis: [
      '🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🫐', '🍈', '🍒', '🍑', '🥭', '🍍', '🥥',
      '🥝', '🍅', '🍆', '🥑', '🥦', '🥬', '🥒', '🌶️', '🫑', '🌽', '🥕', '🫒', '🧄', '🧅', '🥔', '🍠',
      '🥐', '🥯', '🍞', '🥖', '🥨', '🧀', '🥚', '🍳', '🧈', '🥞', '🧇', '🥓', '🥩', '🍗', '🍖', '🦴',
      '🌭', '🍔', '🍟', '🍕', '🫓', '🥪', '🥙', '🧆', '🌮', '🌯', '🫔', '🥗', '🥘', '🫕', '🥫', '🍝',
      '🍜', '🍲', '🍛', '🍣', '🍱', '🥟', '🦪', '🍤', '🍙', '🍚', '🍘', '🍥', '🥠', '🥮', '🍢', '🍡',
      '🍧', '🍨', '🍦', '🥧', '🧁', '🍰', '🎂', '🍮', '🍭', '🍬', '🍫', '🍿', '🍩', '🍪', '🌰', '🥜',
      '🍯', '🥛', '🍼', '☕', '🫖', '🍵', '🧃', '🥤', '🧋', '🍶', '🍺', '🍻', '🥂', '🍷', '🥃', '🍸',
    ],
  },
  {
    id: 'activities',
    title: 'Активности',
    icon: '⚽',
    emojis: [
      '⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱', '🪀', '🏓', '🏸', '🏒', '🏑', '🥍',
      '🏏', '🪃', '🥅', '⛳', '🪁', '🛝', '🏹', '🎣', '🤿', '🥊', '🥋', '🎽', '🛹', '🛼', '🛷', '⛸️',
      '🥌', '🎿', '⛷️', '🏂', '🪂', '🏋️', '🤼', '🤸', '⛹️', '🤺', '🤾', '🏌️', '🏇', '🧘', '🏄', '🏊',
      '🤽', '🚣', '🧗', '🚵', '🚴', '🏆', '🥇', '🥈', '🥉', '🏅', '🎖️', '🏵️', '🎗️', '🎫', '🎟️', '🎪',
      '🤹', '🎭', '🩰', '🎨', '🎬', '🎤', '🎧', '🎼', '🎹', '🥁', '🪘', '🎷', '🎺', '🪗', '🎸', '🪕',
      '🎻', '🎲', '♟️', '🎯', '🎳', '🎮', '🎰', '🧩',
    ],
  },
  {
    id: 'travel',
    title: 'Путешествия',
    icon: '✈️',
    emojis: [
      '🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚐', '🛻', '🚚', '🚛', '🚜', '🦯', '🦽',
      '🦼', '🛴', '🚲', '🛵', '🏍️', '🛺', '🚨', '🚔', '🚍', '🚘', '🚖', '🚡', '🚠', '🚟', '🚃', '🚋',
      '🚞', '🚝', '🚄', '🚅', '🚈', '🚂', '🚆', '🚇', '🚊', '🚉', '✈️', '🛫', '🛬', '🛩️', '💺', '🛰️',
      '🚀', '🛸', '🚁', '🛶', '⛵', '🚤', '🛥️', '🛳️', '⛴️', '🚢', '⚓', '🪝', '⛽', '🚧', '🚦', '🚥',
      '🚏', '🗺️', '🗿', '🗽', '🗼', '🏰', '🏯', '🏟️', '🎡', '🎢', '🎠', '⛲', '⛱️', '🏖️', '🏝️', '🏜️',
      '🌋', '⛰️', '🏔️', '🗻', '🏕️', '⛺', '🏠', '🏡', '🏘️', '🏚️', '🏗️', '🏭', '🏢', '🏬', '🏣', '🏤',
    ],
  },
  {
    id: 'objects',
    title: 'Предметы',
    icon: '💡',
    emojis: [
      '⌚', '📱', '📲', '💻', '⌨️', '🖥️', '🖨️', '🖱️', '🖲️', '🕹️', '🗜️', '💽', '💾', '💿', '📀', '📼',
      '📷', '📸', '📹', '🎥', '📽️', '🎞️', '📞', '☎️', '📟', '📠', '📺', '📻', '🎙️', '🎚️', '🎛️', '🧭',
      '⏱️', '⏲️', '⏰', '🕰️', '⌛', '⏳', '📡', '🔋', '🔌', '💡', '🔦', '🕯️', '🪔', '🧯', '🛢️', '💸',
      '💵', '💴', '💶', '💷', '🪙', '💰', '💳', '💎', '⚖️', '🪜', '🧰', '🪛', '🔧', '🔨', '⚒️', '🛠️',
      '⛏️', '🪚', '🔩', '⚙️', '🪤', '🧱', '⛓️', '🧲', '🔫', '💣', '🧨', '🪓', '🔪', '🗡️', '⚔️', '🛡️',
      '🚬', '⚰️', '🪦', '⚱️', '🏺', '🔮', '📿', '🧿', '💈', '⚗️', '🔭', '🔬', '🕳️', '🩹', '🩺', '💊',
    ],
  },
  {
    id: 'symbols',
    title: 'Символы',
    icon: '❤️',
    emojis: [
      '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔', '❣️', '💕', '💞', '💓', '💗', '💖',
      '💘', '💝', '💟', '☮️', '✝️', '☪️', '🕉️', '☸️', '✡️', '🔯', '🕎', '☯️', '☦️', '🛐', '⛎', '♈',
      '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐', '♑', '♒', '♓', '🆔', '⚛️', '🉑', '☢️', '☣️', '📴', '📳',
      '🈶', '🈚', '🈸', '🈺', '🈷️', '✴️', '🆚', '💮', '🉐', '㊙️', '㊗️', '🈴', '🈵', '🈹', '🈲', '🅰️',
      '🅱️', '🆎', '🆑', '🅾️', '🆘', '❌', '⭕', '🛑', '⛔', '📛', '🚫', '💯', '💢', '♨️', '🚷', '🚯',
      '🚳', '🚱', '🔞', '📵', '🚭', '❗', '❕', '❓', '❔', '‼️', '⁉️', '🔅', '🔆', '〽️', '⚠️', '🚸',
      '🔱', '⚜️', '🔰', '♻️', '✅', '🈯', '💹', '❇️', '✳️', '❎', '🌐', '💠', 'Ⓜ️', '🌀', '💤', '🏧',
      '🚾', '♿', '🅿️', '🛗', '🈳', '🈂️', '🛂', '🛃', '🛄', '🛅', '🚹', '🚺', '🚼', '⚧️', '🚻', '🚮',
      '🎦', '📶', '🈁', '🔣', 'ℹ️', '🔤', '🔡', '🔠', '🆖', '🆗', '🆙', '🆒', '🆕', '🆓', '0️⃣', '1️⃣',
      '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟', '🔢', '#️⃣', '*️⃣', '⏏️', '▶️', '⏸️', '⏯️',
    ],
  },
  {
    id: 'flags',
    title: 'Флаги',
    icon: '🏳️',
    emojis: [
      '🏳️', '🏴', '🏁', '🚩', '🏳️‍🌈', '🏳️‍⚧️', '🇺🇳', '🇷🇺', '🇺🇸', '🇬🇧', '🇩🇪', '🇫🇷', '🇮🇹', '🇪🇸', '🇨🇳', '🇯🇵',
      '🇰🇷', '🇺🇦', '🇧🇾', '🇰🇿', '🇺🇿', '🇹🇷', '🇵🇱', '🇧🇷', '🇮🇳', '🇨🇦', '🇦🇺', '🇲🇽', '🇦🇷', '🇳🇱', '🇸🇪', '🇳🇴',
      '🇫🇮', '🇩🇰', '🇨🇭', '🇦🇹', '🇧🇪', '🇵🇹', '🇬🇷', '🇮🇪', '🇨🇿', '🇸🇰', '🇭🇺', '🇷🇴', '🇧🇬', '🇭🇷', '🇷🇸', '🇧🇦',
    ],
  },
];

/** Quick reactions for the message context menu (Telegram-like). */
export const REACTION_QUICK_EMOJIS = [
  '❤️',
  '👍',
  '👎',
  '🔥',
  '🥰',
  '👏',
  '😁',
  '🤔',
];

const STICKER_PACKS_KEY = 'support-sticker-packs-v1';

type ImageSticker = { id: string; hex: string };
type ImageStickerPack = {
  id: string;
  title: string;
  iconHex: string;
  stickers: ImageSticker[];
};

const openmojiUrl = (hex: string) =>
  `https://cdn.jsdelivr.net/gh/hfg-gmuend/openmoji@15.0.0/color/72x72/${hex.toUpperCase()}.png`;

/** Image sticker packs (OpenMoji) — look like real stickers, send as PNG. */
const CATALOG_STICKER_PACKS: ImageStickerPack[] = [
  {
    id: 'faces',
    title: 'Лица',
    iconHex: '1F60E',
    stickers: [
      '1F600', '1F603', '1F604', '1F601', '1F606', '1F605', '1F602', '1F923',
      '1F60A', '1F607', '1F970', '1F60D', '1F618', '1F61C', '1F92A', '1F914',
      '1F644', '1F624', '1F621', '1F62D', '1F631', '1F633', '1F92F', '1F973',
      '1F921', '1F47B', '1F47D', '1F916', '1F921', '1F4A9', '1F921', '1F60E',
    ].map((hex) => ({ id: hex, hex })),
  },
  {
    id: 'animals',
    title: 'Звери',
    iconHex: '1F43B',
    stickers: [
      '1F436', '1F431', '1F42D', '1F439', '1F430', '1F98A', '1F43B', '1F43C',
      '1F428', '1F42F', '1F981', '1F42E', '1F437', '1F438', '1F435', '1F648',
      '1F649', '1F64A', '1F412', '1F414', '1F427', '1F426', '1F424', '1F986',
      '1F989', '1F987', '1F43A', '1F417', '1F434', '1F984', '1F41D', '1F41B',
    ].map((hex) => ({ id: hex, hex })),
  },
  {
    id: 'food',
    title: 'Еда',
    iconHex: '1F354',
    stickers: [
      '1F34E', '1F34A', '1F34B', '1F34C', '1F349', '1F347', '1F353', '1F352',
      '1F96D', '1F951', '1F346', '1F954', '1F35E', '1F9C0', '1F373', '1F953',
      '1F354', '1F35F', '1F355', '1F32D', '1F32E', '1F32F', '1F959', '1F35C',
      '1F363', '1F371', '1F382', '1F370', '1F36A', '1F369', '1F36B', '1F37A',
    ].map((hex) => ({ id: hex, hex })),
  },
  {
    id: 'gestures',
    title: 'Жесты',
    iconHex: '1F44D',
    stickers: [
      '1F44D', '1F44E', '1F44C', '270C', '1F91E', '1F91F', '1F918', '1F919',
      '1F44F', '1F64C', '1F450', '1F932', '1F64F', '1F4AA', '1F91D', '1F44A',
      '270A', '1F91B', '1F91C', '261D', '1F446', '1F447', '1F448', '1F449',
      '1F595', '1F590', '1F44B', '1F91A', '1F64B', '1F64B', '1F937', '1F926',
    ].map((hex) => ({ id: hex, hex })),
  },
  {
    id: 'love',
    title: 'Любовь',
    iconHex: '2764',
    stickers: [
      '2764', '1F9E1', '1F49B', '1F49A', '1F499', '1F49C', '1F5A4', '1F90D',
      '1F90E', '1F494', '2763', '1F495', '1F49E', '1F493', '1F497', '1F496',
      '1F498', '1F49D', '1F49F', '1F48C', '1F48B', '1F48F', '1F491', '1F46B',
      '1F338', '1F339', '1F33A', '1F33B', '1F33C', '1F490', '1F4AE', '1F3F5',
    ].map((hex) => ({ id: hex, hex })),
  },
  {
    id: 'party',
    title: 'Праздник',
    iconHex: '1F389',
    stickers: [
      '1F389', '1F38A', '1F388', '1F382', '1F381', '1F384', '1F383', '1F386',
      '1F387', '2728', '1F31F', '2B50', '1F525', '1F4A5', '1F4AF', '1F3C6',
      '1F947', '1F948', '1F949', '1F3C5', '1F396', '1F3AB', '1F39F', '1F3AA',
      '1F3B5', '1F3A4', '1F3A7', '1F3B6', '1F3B8', '1F941', '1F3B9', '1F3BA',
    ].map((hex) => ({ id: hex, hex })),
  },
];

const DEFAULT_INSTALLED = ['faces', 'gestures', 'love'];

function loadInstalledPacks(): string[] {
  try {
    const raw = localStorage.getItem(STICKER_PACKS_KEY);
    if (!raw) return [...DEFAULT_INSTALLED];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [...DEFAULT_INSTALLED];
    const ids = parsed.filter((x): x is string => typeof x === 'string');
    return ids.length ? ids : [...DEFAULT_INSTALLED];
  } catch {
    return [...DEFAULT_INSTALLED];
  }
}

function saveInstalledPacks(ids: string[]) {
  try {
    localStorage.setItem(STICKER_PACKS_KEY, JSON.stringify(ids));
  } catch {
    /* ignore */
  }
}

/** Curated reaction GIFs — only verified i.giphy 200w variants (~200–500 KB). */
const GIF_ITEMS: Array<{ id: string; label: string; url: string }> = [
  { id: 'ok', label: 'Ок', url: 'https://i.giphy.com/media/3oEjI6SIIHBdRxXI40/200w.gif' },
  { id: 'cat', label: 'Кот', url: 'https://i.giphy.com/media/JIX9t2j0ZTN9S/200w.gif' },
  { id: 'thumbsup', label: 'Лайк', url: 'https://i.giphy.com/media/YTbZzCkRQCEJa/200w.gif' },
  { id: 'party', label: 'Праздник', url: 'https://i.giphy.com/media/26u4cqiYI30juCOGY/200w.gif' },
  { id: 'mindblown', label: 'Вау', url: 'https://i.giphy.com/media/dzaUX7CAG0Ihi/200w.gif' },
  { id: 'clap', label: 'Аплодисменты', url: 'https://i.giphy.com/media/MDJ9IbxxvDUQM/200w.gif' },
  { id: 'fire', label: 'Огонь', url: 'https://i.giphy.com/media/3o6Zt6ML6BklcajjsA/200w.gif' },
  { id: 'think', label: 'Думаю', url: 'https://i.giphy.com/media/d3mlE7uhX8KFgEmY/200w.gif' },
  { id: 'heart', label: 'Любовь', url: 'https://i.giphy.com/media/l4FGuhL4U2WyjdkaY/200w.gif' },
  { id: 'laugh', label: 'Смех', url: 'https://i.giphy.com/media/10JhviFuU2gWD6/200w.gif' },
  { id: 'wow', label: 'Удивление', url: 'https://i.giphy.com/media/5VKbvrjxpVJCM/200w.gif' },
  { id: 'wave', label: 'Привет', url: 'https://i.giphy.com/media/3o7abKhOpu0NwenH3O/200w.gif' },
];

const GIF_MAX_BYTES = 2.5 * 1024 * 1024;
const STICKER_MAX_BYTES = 512 * 1024;

function loadRecent(): string[] {
  try {
    const raw = localStorage.getItem(RECENT_KEY) || localStorage.getItem('support-emoji-recent-v1');
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((x): x is string => typeof x === 'string').slice(0, RECENT_MAX);
  } catch {
    return [];
  }
}

export function pushRecent(emoji: string) {
  const next = [emoji, ...loadRecent().filter((e) => e !== emoji)].slice(0, RECENT_MAX);
  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {
    /* ignore */
  }
  return next;
}

const LAST_REACTION_KEY = 'support-last-reaction-v1';

export function getLastReaction(): string | null {
  try {
    const raw = localStorage.getItem(LAST_REACTION_KEY);
    const emoji = (raw || '').trim();
    return emoji || null;
  } catch {
    return null;
  }
}

export function setLastReaction(emoji: string) {
  const value = (emoji || '').trim();
  if (!value) return;
  try {
    localStorage.setItem(LAST_REACTION_KEY, value);
  } catch {
    /* ignore */
  }
}

export function IconPaperclip() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M16.5 6.75v8.4a4.5 4.5 0 1 1-9 0V6.3a3 3 0 0 1 6 0v8.1a1.5 1.5 0 1 1-3 0V7.5h1.5v6.9a3 3 0 1 0 6 0V6.3a4.5 4.5 0 1 0-9 0v8.85a6 6 0 1 0 12 0v-8.4Z"
      />
    </svg>
  );
}

export function IconSmile() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8 8 8 0 0 1-8 8Zm-3.2-7.5a1.2 1.2 0 1 1 1.2-1.2 1.2 1.2 0 0 1-1.2 1.2Zm6.4 0a1.2 1.2 0 1 1 1.2-1.2 1.2 1.2 0 0 1-1.2 1.2ZM12 17.2a4.4 4.4 0 0 1-3.7-2h1.5a2.9 2.9 0 0 0 4.4 0h1.5a4.4 4.4 0 0 1-3.7 2Z"
      />
    </svg>
  );
}

export function IconMic() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 14a3 3 0 0 0 3-3V6a3 3 0 0 0-6 0v5a3 3 0 0 0 3 3Zm5-3a5 5 0 0 1-10 0H5a7 7 0 0 0 6 6.92V21h2v-3.08A7 7 0 0 0 19 11Z"
      />
    </svg>
  );
}

export function IconSend() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M3.4 20.6 21 12 3.4 3.4l.1 6.7L15 12 3.5 13.9Z" />
    </svg>
  );
}

function IconGallery() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M19 5H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2Zm0 12H5V7h14Zm-3.2-7.2a1.3 1.3 0 1 1-1.3-1.3 1.3 1.3 0 0 1 1.3 1.3ZM6.5 15.5l3.2-4 2.3 2.9 1.7-2.1 3.8 3.2Z"
      />
    </svg>
  );
}

function IconCheck() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M9.2 16.6 4.8 12.2l1.4-1.4 3 3 8-8 1.4 1.4Z" />
    </svg>
  );
}

export function AttachMenu({
  disabled,
  onPickMedia,
}: {
  disabled?: boolean;
  onPickMedia: () => void;
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement | null>(null);
  const hoverTimer = useRef<number | null>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (!wrapRef.current?.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  const clearHoverTimer = () => {
    if (hoverTimer.current != null) {
      window.clearTimeout(hoverTimer.current);
      hoverTimer.current = null;
    }
  };

  return (
    <div
      className={`support-attach-wrap${open ? ' is-open' : ''}`}
      ref={wrapRef}
      onMouseEnter={() => {
        clearHoverTimer();
        hoverTimer.current = window.setTimeout(() => setOpen(true), 120);
      }}
      onMouseLeave={() => {
        clearHoverTimer();
        hoverTimer.current = window.setTimeout(() => setOpen(false), 180);
      }}
    >
      <button
        type="button"
        className="support-icon-btn"
        title="Прикрепить"
        disabled={disabled}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <IconPaperclip />
      </button>
      {open ? (
        <div className="support-attach-menu" role="menu">
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              setOpen(false);
              onPickMedia();
            }}
          >
            <IconGallery />
            <span>Фото или видео</span>
          </button>
        </div>
      ) : null}
    </div>
  );
}

export function EmojiPickerPanel({
  open,
  onClose,
  onPickEmoji,
  onPickGifFile,
  onPickStickerFile,
  onActivityChange,
  mode = 'compose',
}: {
  open: boolean;
  onClose: () => void;
  onPickEmoji: (emoji: string) => void;
  onPickGifFile?: (file: File) => void;
  onPickStickerFile?: (file: File) => void;
  onActivityChange?: (state: 'selecting_emoji' | 'selecting_sticker' | 'selecting_gif' | null) => void;
  /** compose = emoji+stickers+gif; reaction = unicode emoji only */
  mode?: 'compose' | 'reaction';
}) {
  const [tab, setTab] = useState<'emoji' | 'stickers' | 'gif'>('emoji');
  const [query, setQuery] = useState('');
  const [recent, setRecent] = useState<string[]>(() => loadRecent());
  const [installed, setInstalled] = useState<string[]>(() => loadInstalledPacks());
  const [packId, setPackId] = useState(() => loadInstalledPacks()[0] || 'faces');
  const [stickerBrowse, setStickerBrowse] = useState(false);
  const [catId, setCatId] = useState(EMOJI_CATEGORIES[0]?.id || 'smileys');
  const [mediaBusy, setMediaBusy] = useState<string | null>(null);
  const [mediaError, setMediaError] = useState<string | null>(null);
  const panelRef = useRef<HTMLDivElement | null>(null);
  const onActivityChangeRef = useRef(onActivityChange);
  onActivityChangeRef.current = onActivityChange;
  const reactionOnly = mode === 'reaction';

  const activityForTab = (id: 'emoji' | 'stickers' | 'gif') =>
    id === 'emoji' ? 'selecting_emoji' : id === 'stickers' ? 'selecting_sticker' : 'selecting_gif';

  useEffect(() => {
    if (!open) {
      onActivityChangeRef.current?.(null);
      return;
    }
    onActivityChangeRef.current?.(reactionOnly ? 'selecting_emoji' : activityForTab(tab));
  }, [open, tab, reactionOnly]);

  useEffect(() => {
    if (reactionOnly && tab !== 'emoji') setTab('emoji');
  }, [reactionOnly, tab]);

  useEffect(() => {
    if (!open) return;
    setRecent(loadRecent());
    setInstalled(loadInstalledPacks());
    const onDoc = (e: MouseEvent | TouchEvent) => {
      const target = e.target as Node | null;
      if (!target) return;
      if (panelRef.current?.contains(target)) return;
      if (target instanceof Element && target.closest('[data-emoji-toggle]')) return;
      onClose();
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    // pointerdown so toggle click can flip state without reopen race
    document.addEventListener('pointerdown', onDoc, true);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('pointerdown', onDoc, true);
      document.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  const filteredCats = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return EMOJI_CATEGORIES;
    return EMOJI_CATEGORIES.map((c) => ({
      ...c,
      emojis: c.emojis.filter((e) => e.includes(q) || c.title.toLowerCase().includes(q)),
    })).filter((c) => c.emojis.length > 0);
  }, [query]);

  const installedPacks = useMemo(
    () =>
      installed
        .map((id) => CATALOG_STICKER_PACKS.find((p) => p.id === id))
        .filter((p): p is ImageStickerPack => Boolean(p)),
    [installed],
  );

  if (!open) return null;

  const pickEmoji = (emoji: string) => {
    setRecent(pushRecent(emoji));
    onPickEmoji(emoji);
  };

  const fetchAsImageFile = async (url: string, filename: string, maxBytes: number) => {
    const res = await fetch(url, { mode: 'cors', cache: 'force-cache' });
    if (!res.ok) throw new Error(`http ${res.status}`);
    const blob = await res.blob();
    if (blob.size <= 0) throw new Error('empty');
    if (blob.size > maxBytes) throw new Error('too_large');
    const type = blob.type && blob.type.startsWith('image/') ? blob.type : 'image/png';
    return new File([blob], filename, { type });
  };

  const pickGif = async (item: (typeof GIF_ITEMS)[number]) => {
    if (!onPickGifFile) return;
    setMediaError(null);
    setMediaBusy(item.id);
    try {
      const file = await fetchAsImageFile(item.url, `${item.id}.gif`, GIF_MAX_BYTES);
      onPickGifFile(file);
      onClose();
    } catch {
      setMediaError('Не удалось загрузить GIF. Попробуйте другой.');
    } finally {
      setMediaBusy(null);
    }
  };

  const pickSticker = async (sticker: ImageSticker) => {
    if (!onPickStickerFile) return;
    setMediaError(null);
    setMediaBusy(sticker.id);
    try {
      const file = await fetchAsImageFile(
        openmojiUrl(sticker.hex),
        `sticker-${sticker.hex}.png`,
        STICKER_MAX_BYTES,
      );
      onPickStickerFile(file);
      onClose();
    } catch {
      setMediaError('Не удалось загрузить стикер.');
    } finally {
      setMediaBusy(null);
    }
  };

  const togglePack = (id: string) => {
    setInstalled((prev) => {
      const next = prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id];
      const safe = next.length ? next : [...DEFAULT_INSTALLED];
      saveInstalledPacks(safe);
      if (!safe.includes(packId)) setPackId(safe[0]!);
      return safe;
    });
  };

  const activePack =
    installedPacks.find((p) => p.id === packId) || installedPacks[0] || CATALOG_STICKER_PACKS[0];

  return (
    <div
      className={`support-emoji-panel${reactionOnly ? ' is-reaction' : ''}`}
      ref={panelRef}
      onPointerDown={(e) => e.stopPropagation()}
    >
      {!reactionOnly ? (
        <div className="support-emoji-tabs">
          {(
            [
              ['emoji', 'Эмодзи'],
              ['stickers', 'Стикеры'],
              ['gif', 'GIF'],
            ] as const
          ).map(([id, label]) => (
            <button
              key={id}
              type="button"
              className={tab === id ? 'is-active' : undefined}
              onClick={() => {
                setTab(id);
                setStickerBrowse(false);
                setMediaError(null);
              }}
            >
              {label}
            </button>
          ))}
        </div>
      ) : null}

      {tab === 'emoji' || reactionOnly ? (
        <>
          <div className="support-emoji-search">
            <label className="sr-only" htmlFor="support-emoji-search">
              Поиск эмодзи
            </label>
            <input
              id="support-emoji-search"
              name="emoji_search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Поиск"
              autoComplete="off"
            />
          </div>
          <div className="support-emoji-scroll">
            {recent.length > 0 && !query.trim() ? (
              <section>
                <h4>Недавние</h4>
                <div className="support-emoji-grid">
                  {recent.map((e) => (
                    <button key={`r-${e}`} type="button" className="support-emoji-cell" onClick={() => pickEmoji(e)}>
                      {e}
                    </button>
                  ))}
                </div>
              </section>
            ) : null}
            {filteredCats.map((cat) => (
              <section key={cat.id} id={`emoji-cat-${cat.id}`}>
                <h4>{cat.title}</h4>
                <div className="support-emoji-grid">
                  {cat.emojis.map((e) => (
                    <button key={`${cat.id}-${e}`} type="button" className="support-emoji-cell" onClick={() => pickEmoji(e)}>
                      {e}
                    </button>
                  ))}
                </div>
              </section>
            ))}
          </div>
          <div className="support-emoji-cats">
            <button type="button" title="Недавние" onClick={() => setRecent(loadRecent())}>
              🕒
            </button>
            {EMOJI_CATEGORIES.map((c) => (
              <button
                key={c.id}
                type="button"
                title={c.title}
                className={catId === c.id ? 'is-active' : undefined}
                onClick={() => {
                  setCatId(c.id);
                  document.getElementById(`emoji-cat-${c.id}`)?.scrollIntoView({ block: 'start' });
                }}
              >
                {c.icon}
              </button>
            ))}
          </div>
        </>
      ) : null}

      {!reactionOnly && tab === 'stickers' ? (
        stickerBrowse ? (
          <>
            <div className="support-sticker-browse-head">
              <span>Популярные</span>
              <button type="button" className="support-sticker-done" onClick={() => setStickerBrowse(false)}>
                Готово
              </button>
            </div>
            <div className="support-emoji-scroll">
              <div className="support-sticker-catalog">
                {CATALOG_STICKER_PACKS.map((pack) => {
                  const added = installed.includes(pack.id);
                  return (
                    <div key={pack.id} className="support-sticker-catalog-row">
                      <img src={openmojiUrl(pack.iconHex)} alt="" className="support-sticker-catalog-icon" />
                      <div className="support-sticker-catalog-meta">
                        <strong>{pack.title}</strong>
                        <span>{pack.stickers.length} стикеров</span>
                      </div>
                      <button
                        type="button"
                        className={`support-sticker-add${added ? ' is-added' : ''}`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          togglePack(pack.id);
                        }}
                      >
                        {added ? 'Добавлены' : 'Добавить'}
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="support-emoji-scroll">
              {mediaError ? <p className="support-emoji-gif-error">{mediaError}</p> : null}
              <section>
                <h4>{activePack?.title}</h4>
                <div className="support-sticker-grid">
                  {(activePack?.stickers || []).map((s, idx) => (
                    <button
                      key={`${activePack?.id}-${s.hex}-${idx}`}
                      type="button"
                      className="support-sticker-cell"
                      disabled={mediaBusy != null}
                      onClick={() => void pickSticker(s)}
                    >
                      <img src={openmojiUrl(s.hex)} alt="" loading="lazy" />
                      {mediaBusy === s.id ? <span className="support-gif-busy">…</span> : null}
                    </button>
                  ))}
                </div>
              </section>
              <p className="support-emoji-hint">Стикер отправится сразу</p>
            </div>
            <div className="support-emoji-cats">
              <button type="button" title="Наборы" onClick={() => setStickerBrowse(true)}>
                ⚙️
              </button>
              {installedPacks.map((p) => (
                <button
                  key={p.id}
                  type="button"
                  title={p.title}
                  className={packId === p.id ? 'is-active' : undefined}
                  onClick={() => setPackId(p.id)}
                >
                  <img src={openmojiUrl(p.iconHex)} alt="" className="support-sticker-pack-thumb" />
                </button>
              ))}
            </div>
          </>
        )
      ) : null}

      {!reactionOnly && tab === 'gif' ? (
        <div className="support-emoji-scroll">
          {mediaError ? <p className="support-emoji-gif-error">{mediaError}</p> : null}
          <div className="support-gif-grid">
            {GIF_ITEMS.map((g) => (
              <button
                key={g.id}
                type="button"
                className="support-gif-cell"
                disabled={mediaBusy != null}
                title={g.label}
                onClick={() => void pickGif(g)}
              >
                <img src={g.url} alt={g.label} loading="lazy" />
                {mediaBusy === g.id ? <span className="support-gif-busy">…</span> : null}
              </button>
            ))}
          </div>
          <p className="support-emoji-hint">GIF отправится сразу</p>
        </div>
      ) : null}
    </div>
  );
}

export function SelectionBar({
  count,
  canDelete,
  onForward,
  onDelete,
  onCancel,
}: {
  count: number;
  canDelete: boolean;
  onForward: () => void;
  onDelete: () => void;
  onCancel: () => void;
}) {
  return (
    <div className="support-select-bar">
      <div className="support-select-bar-actions">
        <button type="button" className="support-select-action" onClick={onForward}>
          Переслать {count}
        </button>
        {canDelete ? (
          <button type="button" className="support-select-action" onClick={onDelete}>
            Удалить {count}
          </button>
        ) : null}
      </div>
      <button type="button" className="support-select-cancel" onClick={onCancel}>
        Отмена
      </button>
    </div>
  );
}

export function SelectionCheck({ on }: { on: boolean }) {
  return (
    <span className={`support-msg-check${on ? ' is-on' : ''}`} aria-hidden>
      {on ? <IconCheck /> : null}
    </span>
  );
}
